export const MENU_HEIGHT = 64;
export const SURFER_HEIGHT = 95;
export const TOOLBAR_TO_EDITOR_MARGIN = 26;
